<template>
  <nav
    id="main-navigation"
    role="navigation"
    class="header"
    aria-label="Main site navigation"
  >
    <!-- Top app‑bar -->
    <v-app-bar
      color="primary"
      dense
      app
      clipped-left
      extended
      extension-height="6"
    >
      <!-- Home icon / logo button -->
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            large
            v-bind="attrs"
            :aria-label="$t('components.header.gameName')"
            :to="homeRoute"
            v-on="on"
          >
            <v-avatar
              size="32px"
              tile
            >
              <img
                :src="iconUrl"
                alt="Gods of Zushin logo"
              >
            </v-avatar>
          </v-btn>
        </template>
        <span>{{ $t('components.header.gameName') }}</span>
      </v-tooltip>

      <v-spacer />

      <!-- Notifications component (lazy‑loaded) -->
      <notifications aria-label="User notifications" />

      <!-- App‑bar extension: global loading indicator -->
      <template #extension>
        <page-loading-component aria-label="Page loading indicator" />
      </template>
    </v-app-bar>

    <!-- Global cookies & account deactivation banners (off‑canvas) -->
    <cookies />
    <deactivated />
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
// import { now } from "@/utils/date.utils";
import links from "@/constants/links";

export default {
    name: "HeaderComp",
    components: {
        Notifications: () => import("@/components/Views/Notifications.vue"),
        Cookies: () => import("@/components/Views/Cookies.vue"),
        Deactivated: () =>
            import("@/components/Views/DeactivatedNotification.vue"),
        PageLoadingComponent: () => import("@/components/Views/PageLoading.vue")
    },
    data() {
        return {
            time: "",
            iconUrl: links.assets.icon
        }
    },
    computed: {
      ...mapGetters(['onlineInGame']),
      homeRoute() {
        return { name: 'client.landing' };
      },
    },
    beforeMount() {
        // Always update the time for the users to know current svr time
        // setInterval(() => {
        //     this.time = now().format("ddd D, kk:mm:ss");
        // }, 1000);
    },
};
</script>

<style lang="scss" scoped>
@import '~/_variables.scss';

    .header {
        .v-toolbar__extension {
            padding: 0;
        }

        /* ------------------------------------------------------------------
        * text-colour uses our very-dark primary instead  ✔  contrast ≈ 9.9 : 1
        * ------------------------------------------------------------------*/
        &-internal-link {
                &:hover,
                &:active,
                &.selected {
                background: $accent;
                color: $primary;

                a {
                    color: $primary;
                    text-decoration: none;
                }
            }
        }

        /* Dark-link variation always overlays a dark surface, contrast already OK */
        &-dark-link {
            &:hover {
                a {
                    text-decoration: none;
                    color: $white;
                }
            }
        }
        &-total-online {
            color: $success;
        }
        &-nickname {
            background: $primary!important;
            color: $white;
        }
        &-system-requirments-button {
            background: $primary!important;
        }
    }
</style>
